@import "@zvuk-b2b/react-uikit/ui/styles/_variables";
@import "@zvuk-b2b/react-uikit/ui/styles/_mixins";

.ContactWithManagerButton {
    display: flex;
    align-items: center;
    justify-content: center;

    @include media-desktop {
        box-shadow: $shadow-l;
        border-radius: 100%;
        background-color: $color-white;
    }
}
